import { PageType } from 'AppShell/appshell_types/routingTypes';

export const LandingPagePrefix = {
    STUDIO: 'studio',
} as const;

export const ResponsiveTabletPageTypes = [PageType.CART_NATIVE, PageType.ASSEMBLYSERVICE, PageType.SHIPPING_INFO];

export const ContentInfusionsAllowedPageTypes = [
    PageType.CATEGORY,
    PageType.LANDING,
    PageType.BRANDS,
    PageType.NEWPRODUCTS,
];

export const ProductListingPages = [
    PageType.CATEGORY,
    PageType.NEWPRODUCTS,
    PageType.ALLPRODUCTS,
    PageType.LANDING,
    PageType.BRANDS,
];

export const ContentInfusionsPageTypeMapping = {
    [PageType.LANDING]: 'landing',
    [PageType.NEWPRODUCTS]: 'newproducts',
};

export enum FilterFacetsNames {
    DELIVERY_TIME = 'facet_delivery_time',
    PRICE = 'facet_price',
    STYLES = 'facet_styles',
}

export const WishListUrlList = [
    '/customer/wishlist',
    '/customer/wishlist/',
    '/customer/wishlist/index',
    '/customer/wishlist/index/',
];

export const MediaInfusionAllowedPageTypes = [PageType.CATEGORY, PageType.LANDING, PageType.BRANDS];
